import { useEffect, useState } from "react"
import { Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "../../../global/ModalBase"
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { obtenerCicuitosProvedor, } from "../../../ducks/proveedorTerrestreDuck"
import { makeStyles } from "@material-ui/core"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import TCircuitosVuelo from "./TCircuitosVuelo"
import { closeCircuitoVueloAction, crearVueloCircuito, obtenerCircuitoVueloAction, obtenerTerrestreAllListaAction } from "../../../ducks/proveedorAereolineaDuck"
export const FormularioReservaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const useVueloCircuitoProveedor = ({ id }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCircuitoVueloAction({ IdProveedor: id })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, id])
}

const useProveedoresTerrestes = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerTerrestreAllListaAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}

const useProvedorTerrestreCircuitos = ({ id }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCicuitosProvedor({ id })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, id])
}

const FCircuitosVuelo = () => {
    const [proveedorTerrestre, setProveedorTerrestre] = useState(0)
    const [circuito, setCircuito] = useState(0)
    const { arrayCircuitos } = useSelector(store => store.proveedorTerrestre)
    const { openModalCircuitoVuelo, vueloTarget, listaPaqueteTerrestres } = useSelector(store => store.vueloProveedor)
    useProvedorTerrestreCircuitos({ id: proveedorTerrestre })
    useVueloCircuitoProveedor({ id: vueloTarget?.IdVuelo })
    const dispatch = useDispatch()
    const classes = FormularioReservaStyle()
    useProveedoresTerrestes()
    const clearForm = () => {
        setProveedorTerrestre(0)
        setCircuito(0)
    }
    const handleClose = () => {
        clearForm()
        dispatch(closeCircuitoVueloAction())
    }
    const handleClickSave = () => {
        dispatch(onLoadAnction({ message: '' }))
        dispatch(crearVueloCircuito({
            IdPaqueteCircuito: circuito,
            IdVueloProveedor: vueloTarget?.IdVuelo
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerCircuitoVueloAction({ IdProveedor: vueloTarget?.IdVuelo }))
            clearForm()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }
    const handleSelecProveedorTerrestre = (event) => {
        setProveedorTerrestre(event.target.value)
    }
    const handleSelecProveedorTerrestreCircuito = (event) => {
        setCircuito(event.target.value)
    }
    return (
        <div>
            <ModalBase classes={classes} open={openModalCircuitoVuelo} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Circuito vuelo`}
                />
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <FormControl variant="outlined">
                            <InputLabel id="lCircuitProveedorTerrestre">Proveedor terrestre</InputLabel>
                            <Select
                                labelId="lCircuitProveedorTerrestre"
                                id="SCProveedorTerreste"
                                name="proveedorTerrestre"
                                value={proveedorTerrestre}
                                onChange={handleSelecProveedorTerrestre}
                                label="Proveedor terrrestre"
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {listaPaqueteTerrestres.map((paquete, index) => (
                                    <MenuItem key={paquete.IdPaqueteProveedorTerrestre} value={paquete.IdPaqueteProveedorTerrestre}>
                                        {`${paquete.ClavePaquete} - ${paquete.Nombre}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl variant="outlined">
                            <InputLabel id="lCircuitProveedorTerrestreCiruitos">Fechas paquete</InputLabel>
                            <Select
                                labelId="lCircuitProveedorTerrestreCiruitos"
                                id="SCProveedorTerresteCircuitos"
                                name="proveedorTerrestreCircuitos"
                                value={circuito}
                                onChange={handleSelecProveedorTerrestreCircuito}
                                label="Proveedor terrrestre"
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {arrayCircuitos.map((ciruito, index) => (
                                    <MenuItem key={ciruito.IdPaqueteCircuito} value={ciruito.IdPaqueteCircuito}>
                                        {`${ciruito.FechaInicio} - ${ciruito.FechaFin}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            onClick={handleClickSave}
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <TCircuitosVuelo />
                </Grid>
            </ModalBase>
        </div>
    )
}
export default FCircuitosVuelo